module.exports = __webpack_public_path__ + "img/lipin.d48fa15c.png";